export const generateICSFile = (newEvent) => {
  const cal = window.ics(newEvent.UID)
  cal.addEvent(newEvent.SUMMARY, newEvent.DESCRIPTION, newEvent.PRODID, newEvent.DTSTART, newEvent.DTEND)
  cal.download(newEvent.SUMMARY)
}